import { render } from "./CustomFooter.vue?vue&type=template&id=67fe1772&scoped=true"
const script = {}

import "./CustomFooter.vue?vue&type=style&index=0&id=67fe1772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fe1772"]])

export default __exports__